module.exports = __webpack_public_path__ + "img/logo_SPB.153e59b.png";